import { createFileRoute } from '@tanstack/react-router';
import SemanticEntityAgGridRoute from '@/features/semantic-entities/SemanticEntityAgGridRoute.tsx';

export const Route = createFileRoute('/field-services/support-cases/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <SemanticEntityAgGridRoute entityId="supportCase" />;
}
